import { render, staticRenderFns } from "./CarsList.vue?vue&type=template&id=72b2f926"
import script from "./CarsList.vue?vue&type=script&lang=js"
export * from "./CarsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FlightsLoading: require('/home/forge/farescraper.com/components/FlightsLoading.vue').default})
